import Axios from "axios";
import md5 from "md5";
import { toast } from "react-toastify";
// Constants
import { WEB_SERVICE_ROUTE } from "../config/constants";

// ----- State -----
const initialState = {
  isFetching: false,
  isLoggedIn: false,
  enteredAcrossLogin: false,
  data: {},
};

// ----- Types -----
// LOGIN
const CLINICIAN_LOGIN_STARTED = "CLINICIAN_LOGIN_STARTED";
const CLINICIAN_LOGIN_DONE = "CLINICIAN_LOGIN_DONE";
const CLINICIAN_LOGIN_ERROR = "CLINICIAN_LOGIN_ERROR";
// SET TOKEN
const CLINICIAN_VERIFY_TOKEN = "CLINICIAN_VERIFY_TOKEN";
// LOGOUT
const CLINICIAN_LOGOUT = "CLINICIAN_LOGOUT";

// ----- Reducer -----
export default function reducer(state = initialState, action) {
  switch (action.type) {
    //CLINICIAN LOGIN
    case CLINICIAN_LOGIN_STARTED:
      return {
        ...state,
        isFetching: true,
      };
    case CLINICIAN_LOGIN_DONE:
      return {
        ...state,
        isFetching: false,
        isLoggedIn: true,
        enteredAcrossLogin: true,
        data: action.payload.data,
      };
    case CLINICIAN_LOGIN_ERROR:
      return {
        ...state,
        isFetching: false,
        isLoggedIn: false,
        enteredAcrossLogin: false,
      };
    //CLINICIAN VERIFY TOKEN
    case CLINICIAN_VERIFY_TOKEN:
      return {
        ...state,
        isFetching: false,
        isLoggedIn: true,
        data: action.payload.data,
      };
    //CLINICIAN LOGOUT
    case CLINICIAN_LOGOUT:
      return {
        ...state,
        isFetching: false,
        isLoggedIn: false,
        enteredAcrossLogin: false,
        data: {},
      };
    default:
      return state;
  }
}

// ----- Actions -----
// LOGIN
export const validateClinician =
  ({ user, password, errorMessage }) =>
  async (dispatch) => {
    dispatch({ type: CLINICIAN_LOGIN_STARTED });
    const encryptedPassword = password === "" ? "" : md5(`${user}${password}`);
    const URL = `${WEB_SERVICE_ROUTE}/login/clinician`;
    await Axios.post(URL, {
      CLINICIAN_USER: user,
      PASSWORD: encryptedPassword,
    })
      .then(({ data }) => {
        if (data.token) {
          dispatch({
            type: CLINICIAN_LOGIN_DONE,
            payload: {
              data,
            },
          });
        } else {
          dispatch({
            type: CLINICIAN_LOGIN_ERROR,
          });
          return toast.error(errorMessage);
        }
      })
      .catch((error) => {
        console.log("url error: ", error);
      });
  };

// SET TOKEN
export const clinicianVerifyToken =
  ({ data }) =>
  (dispatch) => {
    dispatch({
      type: CLINICIAN_VERIFY_TOKEN,
      payload: {
        data,
      },
    });
  };

//LOGOUT
export const clinicianLogout = () => (dispatch) => {
  dispatch({ type: CLINICIAN_LOGOUT });
};
